define(function(require){

    var locales = {};
    locales["fr"] = {
        required: "Le champ est requis",
        stringLengthBetween: function (min, max) { return "Le champ doit faire entre " + min + " et " + max + " caractères"; },
        stringLengthMin: function (min) { return "Le champ doit faire au moins " + min + " caractères"; },
        stringLengthMax: function (max) { return "Le champ doit faire au maximum " + max + " caractères"; },
        stringLengthEqual: function (eq) { return "Le champ doit mesurer " + eq + " caractères"; },
        isin: "Le code ISIN est invalide",
        iban: "L'IBAN est invalide",
        bic: "Le code BIC est invalide",
        email: "L'adresse email est invalide",
        url: "L'url est invalide",
		number: "Ce champ ne peut contenir que des chiffres",
		numberInteger: "Ce champ doit être un entier",
        numberMin: function (min) { return "La valeur doit être supérieure à : " + min; },
        numberMax: function (max) { return "La valeur doit être inférieure à : " + max; },
        onlyString: "Ce champ ne peut contenir que des lettres",
        phoneNumber: "Ce champ doit être un numéro de téléphone",
        pattern: "La saisie est invalide",
        autocomplete: "Vous n'avez pas sélectionné d'élément",
        dateFormat: "Le format de la date est invalide",
        dateMin: "La date doit être supérieure",
        dateMax: "La date doit être inférieure",
        atLeastOneChecked: "Vous devez renseigner au moins un des champs",
        atLeastOne: "Vous devez valider au moins un des champs",
        equalField: function (name) { return "Ce champ doit être égal au champ " + name; },
        differentField: function (name) { return "Ce champ doit être différent du champ " + name; },
        unauthorized: "Ce champ ne peut pas avoir cette valeur",
        default: "Une erreur est survenue sur le champ"
    };

    locales["it"] = {
        required: "È necessario compilare il campo",
        stringLengthBetween: function (min, max) { return "Il campo deve misurare tra " + min + " e " + max + " caratteri"; },
        stringLengthMin: function (min) { return "Il campo deve misurare almeno " + min + " caratteri"; },
        stringLengthMax: function (max) { return "Il campo deve misurare al massimo " + max + " caratteri"; },
        stringLengthEqual: function (eq) { return "Il campo deve misurare " + eq + " caratteri"; },
		isin: "Il codice ISIN non è valido",
		iban: "Il IBAN non è valido",
		bic: "Il codice BIC non è valido",
        email: "L’indirizzo mail non è valido",
        url: "L'url non è valida",
		number: "Questo campo può contenere solo caratteri numerici",
		numberInteger: "Questo campo deve essere un numero intero",
        numberMin: function (min) { return "Il valore deve essere superiore a : " + min; },
        numberMax: function (max) { return "Il valore deve essere inferiore a : " + max; },
        onlyString: "Questo campo può contenere solo caratteri alfabetici",
        phoneNumber: "Questo campo deve essere un numero di telefono",
        pattern: "Compilazione non valida",
        autocomplete: "Nessun elemento è stato selezionato",
        dateFormat: "Il formato della data non è valido",
        dateMin: "La data deve essere successiva",
        dateMax: "La data deve essere precedente",
        atLeastOneChecked: "È necessario compilare almeno un campo",
        atLeastOne: "È necessario confermare almeno un campo",
        equalField: function (name) { return "Questo campo deve essere uguale al campo " + name; },
        differentField: function (name) { return "Questo campo deve essere diverso dal campo " + name; },
        unauthorized: "Questo campo non può avere questo valore",
        default: "Si è verificato un errore su questo campo"
	};

	locales["en"] = {
		required: "This field is required",
		stringLengthBetween: function (min, max) { return "This field should be between" + min + " and " + max + " characters long"; },
		stringLengthMin: function (min) { return "This field should be at least " + min + " characters long"; },
		stringLengthMax: function (max) { return "This field should be at most " + max + " characters long"; },
		stringLengthEqual: function (eq) { return "This field must be exactly " + eq + " characters long"; },
		isin: "Invalid ISIN code",
        iban: "Invalid IBAN",
		bic: "Invalid BIC/SWIFT code",
		email: "Invalid email address",
		url: "Invalid url",
		number: "This field can only contain numbers",
		numberInteger:"This field must be an integer",
		numberMin: function (min) { return "This value must be greater than : " + min; },
		numberMax: function (max) { return "This value must be less than : " + max; },
		onlyString: "This field can only contain letters",
		phoneNumber: "This field should contain a telephone number",
		pattern: "Invalid input",
		autocomplete: "Please select an item",
		dateFormat: "Invalid date format",
		dateMin: "A later date is required",
		dateMax: "An earlier date is required",
		atLeastOneChecked: "Please fill at least one field",
		atLeastOne: "Please confirm at least one field",
		equalField: function (name) { return "This field must be equal to the '" + name+"' field"; },
		differentField: function (name) { return "This field must be different than the '" + name + "' field"; },
		unauthorized: "This value is not allowed",
		default: "Field error"
	};

    return locales;
});
